import { Injectable } from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';

import { AccountingChangeOptionsModel } from './typings/admin-dashboard.accounting-change.options';
import { ApiService }                   from '../api/api.service';
import { ChangeAccountingComponent }    from './admin-dashboard.change-accounting.component';
import { CodeTypeModel }                from '../core/models/code-type';
import { SessionCompanyModel }          from '../sessions/models/session.company';

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService {

  constructor (
    private apiService  : ApiService,
    private modalService: NgbModal,
  ) {}

  changeAccountingIntegration ( company : SessionCompanyModel ) : Promise<void> {
    const modalRef = this.modalService.open(ChangeAccountingComponent, {
        windowClass: 'lg-modal'
      });

    modalRef.componentInstance.company = company;

    return modalRef.result;
  }

  confirmAccountingChange ( options : AccountingChangeOptionsModel ) : Promise<any> {


    return this.apiService.post('/accounting_change/action', options);


  }

  getAccountingChangeInvoiceOptions () : Array<CodeTypeModel> {
    return [
      {
        code          : 'A',
        description   : 'Sync ALL Invoices',
        language_label: 'DASHBOARD_SPACE.ADMIN_DASHBOARD.ACCOUNTING_CHANGE.SYNC_ALL_INVOICES'
      },
      {
        code          : 'B',
        description   : 'Sync Invoices ON/AFTER date',
        language_label: 'DASHBOARD_SPACE.ADMIN_DASHBOARD.ACCOUNTING_CHANGE.SYNC_INVOICES_ON_AFTER_DATE'
      },{
        code          : 'C',
        description   : 'Sync Invoices from TODAY',
        language_label: 'DASHBOARD_SPACE.ADMIN_DASHBOARD.ACCOUNTING_CHANGE.SYNC_INVOICES_FROM_TODAY'
      }
    ];
  }

  getAccountingChangePackages () : Array<CodeTypeModel> {
    return [
      {
        code          : 'myob',
        description   : 'Myob',
        language_label: 'COMPANY_SPACE.INTEGRATIONS.MYOB.MYOB_LABEL'
      },
      {
        code          : 'qbo',
        description   : 'QuickBooks',
        language_label: 'COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS'
      },
      {
        code          : 'xero',
        description   : 'Xero',
        language_label: 'COMPANY_SPACE.INTEGRATIONS.XERO.XERO'
      }
    ];
  }
}
